module.exports = __webpack_public_path__ + "img/givenchy_reveal.d0f73949.jpg";